import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import RegistrationRequestList from "./RegistrationRequestList";
import {canManageRegistrationRequests} from "../../../PermissionSelectors";

class RegistrationRequestsPage extends Component {

  constructor(props) {
    super(props);
    this.state = { requests: [] };
  }

  componentDidMount() {
    this.props.getRequests().then(requests => {
      this.setState({ requests: requests });
    });
  }

  render() {
    return (
      <div className={"container"}>
        {
          this.props.canAccess ?
            <div className="row">
              <div className="col-md-12">
                <RegistrationRequestList requests={this.state.requests} />
              </div>
            </div>
            : null
          }
      </div>
    );
  }
}

RegistrationRequestsPage.propTypes = {
  getRequests: PropTypes.func.isRequired,
};

export default connect((state, props) => ({
  canAccess: canManageRegistrationRequests(state, props) 
}))(RegistrationRequestsPage);
